<style lang="scss">
.tz-search {
  align-items: start;
  * {
    box-sizing: border-box;
  }
  &__people {
    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
  &__phone {
    width: 100%;
  }
  &__button-image {
    height: 12px;
    margin: {
      right: 0;
      bottom: 11px;
    }
  }
  &__form {
    margin: 0;
    position: relative;
    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
    }
  }
  &__form-group {
    position: relative;
  }
  &__input-field {
    display: block;
    width: 100%;
    // Remove select outline from select box in FF
    &:-moz-focusring {
      color: transparent;
      text-shadow: 0 0 0 #d9dae0;
    }
    &--invalid {
      background-image: url('./images/cross.svg');
      background-repeat: no-repeat;
      background-position: right 10px center;
    }
    &--valid {
      background-image: url('./images/check_success.svg');
      background-repeat: no-repeat;
      background-position: right 10px center;
    }
    &--select {
      word-wrap: normal;
      -webkit-appearance: none;
      background: #fff url('./images/arrow-down.svg') no-repeat right 16px
        center;
    }
  }
  &__tooltip {
    display: inline-block;
    max-width: 100%;
    z-index: 1;
    position: absolute;
    bottom: 90%;
    left: 16px;
    background-color: #00ff00;
    color: white;
    font-size: 14px;
    border-radius: 4px;
    padding: 4px 8px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
    &:before {
      position: absolute;
      content: '';
      bottom: -5px;
      left: 16px;
      border-top: 6px solid #00ff00;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
  }
  &__search-icon {
    background-position: center;
    background-repeat: no-repeat;
    height: 17px;
    width: 30px;
  }
}
</style>
<template>
  <div
    class="tz-search"
    :class="{ 'tz-search--phone-search': hasOnlyPhoneSearch }"
  >
    <div v-if="hasPhoneSearch && hasPeopleSearch" class="tz-search__type">
      <button
        class="tz-search__button"
        :class="{ 'tz-search__button--active': isPeopleSearch() }"
        @click="toggleSearchType('people')"
        :aria-label="setPeopleLabel"
      >
        <img
          aria-hidden="true"
          alt="Search Button Icon"
          class="tz-search__button-image"
          :src="(buttonIcons && buttonIcons.people) || peopleIcon"
          loading="lazy"
          height="12"
          width="12"
        />
        <span class="tz-search__button-text" aria-hidden="true">People</span>
      </button>
      <button
        class="tz-search__button"
        :class="{ 'tz-search__button--active': isPhoneSearch() }"
        @click="toggleSearchType('phone')"
        :aria-label="setPhoneLabel"
      >
        <img
          aria-hidden="true"
          alt="Search Button Icon"
          class="tz-search__button-image"
          :src="(buttonIcons && buttonIcons.phone) || phoneIcon"
          loading="lazy"
          height="12"
          width="12"
        />
        <span class="tz-search__button-text" aria-hidden="true">Phone</span>
      </button>
      <button
        v-for="addressBtn in renderIf(hasAddressSearch)"
        :key="addressBtn"
        class="tz-search__button"
        :class="{ 'tz-search__button--active': isAddressSearch() }"
        @click="toggleSearchType('address')"
        :aria-label="setAddressLabel"
      >
        <img
          aria-hidden="true"
          alt="Search Button Icon"
          class="tz-search__button-image"
          :src="(buttonIcons && buttonIcons.address) || addressIcon"
          loading="lazy"
          height="12"
          width="12"
        />
        <span class="tz-search__button-text" aria-hidden="true">Address</span>
      </button>
    </div>
    <div
      v-for="item in renderIf(isPeopleSearch())"
      :key="item + '_people'"
      class="tz-search__people"
    >
      <div class="tz-search__form" @keypress.enter="searchSubmit">
        <tz-markdown
          v-for="item in renderIf(startLabel)"
          :key="item"
          :class="'tz-search__tooltip'"
          :content="startLabel"
        />
        <div class="tz-search__form-group">
          <input
            type="text"
            class="tz-search__input-field"
            name="firstName"
            ref="firstName"
            placeholder="First Name"
            aria-label="First Name"
            maxlength="255"
            v-bind:class="[
              setValidationClass('firstName'),
              error.firstName
                ? 'tz-search__input-field--invalid'
                : prefillFields.firstName === ''
                ? ''
                : 'tz-search__input-field--valid'
            ]"
            v-model.trim="prefillFields.firstName"
            @input="onPeopleInput($event)"
          />
        </div>
        <div class="tz-search__form-group">
          <input
            type="text"
            class="tz-search__input-field"
            name="lastName"
            maxlength="255"
            ref="lastName"
            placeholder="Last Name"
            aria-label="Last Name"
            v-bind:class="[
              setValidationClass('lastName'),
              error.lastName
                ? 'tz-search__input-field--invalid'
                : prefillFields.lastName === ''
                ? ''
                : 'tz-search__input-field--valid'
            ]"
            v-model.trim="prefillFields.lastName"
            @input="onPeopleInput($event)"
          />
        </div>
        <div class="tz-search__form-group">
          <input
            type="text"
            class="tz-search__input-field"
            name="city"
            maxlength="255"
            ref="city"
            placeholder="City"
            aria-label="City"
            v-model.trim="prefillFields.city"
            @input="onPeopleInput($event)"
          />
        </div>
        <div class="tz-search__form-group">
          <select
            class="tz-search__input-field tz-search__input-field--select"
            aria-label="State"
            ref="state"
            name="state"
            @change="onStateChange($event)"
            v-model="prefillFields.state"
          >
            <option value="">{{
              defaultStateLabel.length ? defaultStateLabel : 'State'
            }}</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
        </div>
        <div
          v-for="item in renderIf(isPhoneSearch())"
          :key="item"
          class="tz-search__form-group"
        >
          <input
            type="text"
            class="tz-search__input-field tz-search__input-field--phone"
            name="phoneNumber"
            ref="phone"
            :placeholder="defaultPhoneLabel"
            :aria-label="defaultPhoneLabel"
            v-model="prefillFields.phoneNumber"
          />
        </div>
        <button
          class="tz-search__btn-search"
          :class="{ 'tz-search__btn-search--display-text': displaySearchText }"
          @click="searchSubmit"
          aria-label="Search"
        >
          <span class="tz-search__btn-text" aria-hidden="true"
            >Search<img
              v-for="item in renderIf(shouldShowTextSearchIcon)"
              :key="item"
              class="tz-search__btn-text-icon"
              :src="textSearchIcon"
              alt="Search Icon"
              :aria-hidden="true"
              loading="lazy"
              :height="textSearchIconSize.height"
              :width="textSearchIconSize.width"
            />
          </span>
          <span
            class="tz-search__search-icon"
            :style="backgroundStyle"
            aria-hidden="true"
          />
        </button>
      </div>
      <div
        v-for="item in renderIf(shouldShowSecureText)"
        :key="item"
        class="tz-search__secured"
      >
        <img
          v-for="item in renderIf(shouldShowSecureIcon)"
          :key="item"
          :src="secureIcon"
          class="tz-search__secured-icon"
          alt="'Lock Icon'"
          aria-hidden="true"
          loading="lazy"
          :height="secureIconSize.height"
          :width="secureIconSize.width"
        />
        <p class="tz-search__secured-text">
          <em>{{ secureConnectionText }}</em>
        </p>
      </div>
    </div>

    <div
      v-for="item in renderIf(hasOnlyPhoneSearch || isPhoneSearch())"
      :key="item"
      class="tz-search__phone"
    >
      <tz-markdown
        v-for="item in renderIf(startLabel)"
        :key="item"
        :class="'tz-search__tooltip'"
        :content="startLabel"
      />
      <div
        class="tz-search__form tz-search__form--phone"
        @keypress.enter="searchSubmit"
      >
        <div class="tz-search__form-group">
          <input
            type="tel"
            class="tz-search__input-field tz-search__input-field--phone"
            name="phoneNumber"
            ref="phone"
            :placeholder="defaultPhoneLabel"
            :aria-label="defaultPhoneLabel"
            v-model="prefillFields.phoneNumber"
            @keyup.delete="onPhoneInput($event)"
            @input="onPhoneInput($event)"
            maxlength="14"
            v-bind:class="[
              setValidationClass('phone'),
              error.phone
                ? 'tz-search__input-field--invalid'
                : 'tz-search__input-field--valid'
            ]"
          />
        </div>
        <button
          class="tz-search__btn-search"
          :class="{ 'tz-search__btn-search--display-text': displaySearchText }"
          @click="searchSubmit"
          :aria-label="setSearchButtonLabel()"
        >
          <span class="tz-search__btn-text" aria-hidden="true"
            >Search<img
              v-for="item in renderIf(shouldShowTextSearchIcon)"
              :key="item"
              class="tz-search__btn-text-icon"
              :src="textSearchIcon"
              alt="Search Icon"
              :aria-hidden="true"
              loading="lazy"
              :height="textSearchIconSize.height"
              :width="textSearchIconSize.width"
            />
          </span>
          <span
            class="tz-search__search-icon"
            :style="backgroundStyle"
            aria-hidden="true"
          />
        </button>
      </div>
      <div
        v-for="item in renderIf(shouldShowSecureText)"
        :key="item"
        class="tz-search__secured"
      >
        <img
          v-for="item in renderIf(shouldShowSecureIcon)"
          :key="item"
          :src="secureIcon"
          class="tz-search__secured-icon"
          alt="'Lock Icon'"
          aria-hidden="true"
          loading="lazy"
          :height="secureIconSize.height"
          :width="secureIconSize.width"
        />
        <p class="tz-search__secured-text">
          <em>{{ secureConnectionText }}</em>
        </p>
      </div>
    </div>

    <div
      v-for="addressItem in renderIf(hasOnlyAddressSearch || isAddressSearch())"
      :key="addressItem"
      class="tz-search__address"
    >
      <div
        class="tz-search__form tz-search__form--address"
        @keypress.enter="searchSubmit"
      >
        <tz-markdown
          v-for="item in renderIf(startLabel)"
          :key="item"
          :class="'tz-search__tooltip'"
          :content="startLabel"
        />
        <div class="tz-search__form-group">
          <input
            type="text"
            class="tz-search__input-field"
            name="street"
            maxlength="255"
            ref="street"
            placeholder="Street"
            aria-label="Street"
            v-bind:class="[
              setValidationClass('street'),
              error.street
                ? 'tz-search__input-field--invalid'
                : prefillFields.street === ''
                ? ''
                : 'tz-search__input-field--valid'
            ]"
            v-model.trim="prefillFields.street"
            @input="onAddressInput($event)"
          />
        </div>
        <div class="tz-search__form-group">
          <input
            type="text"
            class="tz-search__input-field"
            name="city"
            maxlength="255"
            ref="city"
            placeholder="City"
            aria-label="City"
            v-bind:class="[
              setValidationClass('city'),
              !searchSubmitted.address &&
              prefillFields.city === '' &&
              error.city
                ? ''
                : error.city
                ? 'tz-search__input-field--invalid'
                : prefillFields.city === ''
                ? ''
                : 'tz-search__input-field--valid'
            ]"
            v-model.trim="prefillFields.city"
            @input="onCityInput($event)"
          />
        </div>
        <div class="tz-search__form-group">
          <select
            class="tz-search__input-field tz-search__input-field--select"
            aria-label="State"
            ref="state"
            name="state"
            @change="onStateChange($event)"
            v-model="prefillFields.state"
          >
            <option value="" disabled>{{
              defaultStateLabel.length ? defaultStateLabel : 'State'
            }}</option>
            <option
              v-for="(key, value) in states"
              :key="value"
              :value="value"
              >{{ key }}</option
            >
          </select>
        </div>
        <button
          class="tz-search__btn-search"
          :class="{ 'tz-search__btn-search--display-text': displaySearchText }"
          @click="searchSubmit"
          aria-label="Search"
        >
          <span class="tz-search__btn-text" aria-hidden="true"
            >Search<img
              v-for="item in renderIf(shouldShowTextSearchIcon)"
              :key="item"
              class="tz-search__btn-text-icon"
              :src="textSearchIcon"
              alt="Search Icon"
              :aria-hidden="true"
              loading="lazy"
              :height="textSearchIconSize.height"
              :width="textSearchIconSize.width"
            />
          </span>
          <span
            class="tz-search__search-icon"
            :style="backgroundStyle"
            aria-hidden="true"
          />
        </button>
      </div>
      <div
        v-for="item in renderIf(shouldShowSecureText)"
        :key="item"
        class="tz-search__secured"
      >
        <img
          v-for="item in renderIf(shouldShowSecureIcon)"
          :key="item"
          :src="secureIcon"
          class="tz-search__secured-icon"
          alt="'Lock Icon'"
          aria-hidden="true"
          loading="lazy"
          :height="secureIconSize.height"
          :width="secureIconSize.width"
        />
        <p class="tz-search__secured-text">
          <em>{{ secureConnectionText }}</em>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
//Regex for Valid Characters i.e. Alphabets.
const isValidAlphabet = new RegExp(/^[A-Za-z-\s]+$/);
const searchTypes = ['people', 'phone', 'address'];

import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';
import SearchIcon from './images/search.svg';
import peopleIcon from './images/people-search-white-icon.svg';
import phoneIcon from './images/phone.svg';
import addressIcon from './images/address.svg';
const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

export default {
  name: 'TzSearch',
  components: {
    TzMarkdown
  },
  computed: {
    phoneAreaCode() {
      return (
        '(' +
        this.phoneRaw.substr(0, 3) +
        (this.phoneRaw.length > 3 ? ') ' : '')
      );
    },
    phonePrefix() {
      return this.phoneRaw.substr(3, 3);
    },
    phoneLine() {
      return this.phoneRaw.length < 7 ? '' : '-' + this.phoneRaw.substr(6, 4);
    },
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.searchIconImage})`
      };
    },
    hasPhoneSearch() {
      return this.phoneLink !== null;
    },
    hasPeopleSearch() {
      return this.peopleLink !== null;
    },
    hasAddressSearch() {
      return this.addressLink !== null;
    },
    hasOnlyPhoneSearch() {
      return (
        this.hasPhoneSearch && !this.hasPeopleSearch && !this.hasAddressSearch
      );
    },
    hasOnlyAddressSearch() {
      return (
        this.hasAddressSearch && !this.hasPeopleSearch && !this.hasPhoneSearch
      );
    },
    searchIconImage() {
      return this.searchIcon === null ? SearchIcon : this.searchIcon;
    },
    setPeopleLabel() {
      return 'People Search' + (this.isPeopleSearch() ? ', Current' : '');
    },
    setPhoneLabel() {
      return 'Phone Search' + (this.isPhoneSearch() ? ', Current' : '');
    },
    setAddressLabel() {
      return 'Address Search' + (this.isAddressSearch() ? ', Current' : '');
    },
    shouldShowSecureText() {
      return this.secureConnectionText !== null;
    },
    shouldShowSecureIcon() {
      return this.shouldShowSecureText && this.secureIcon !== null;
    },
    shouldShowTextSearchIcon() {
      return this.displaySearchText && this.textSearchIcon;
    }
  },
  props: {
    // Boolean to display search text rather than icon
    displaySearchText: {
      type: Boolean,
      default: false
    },
    // Open Search Results in New Window
    openNewWindow: {
      type: Boolean,
      default: false
    },
    // Regex to prevent characters in people inputs
    peopleInvalidRegex: {
      type: RegExp,
      default: null
    },
    // People Search Results Base URL
    peopleLink: {
      type: String,
      default: null
    },
    // Phone Search Results Base URL
    phoneLink: {
      type: String,
      default: null
    },
    // Address Search Results Base URL
    addressLink: {
      type: String,
      default: null
    },
    // Prefill Form Fields using URL Parameters from this.$route.query
    prefillFields: {
      type: Object,
      required: true,
      default: Object
    },
    // Fallback Form Fields for each of the search types
    fallbackFields: {
      type: Array,
      default: null
    },
    //state to load if no params present
    initialSearchType: {
      type: String,
      default: 'people'
    },
    // Icon to use for the search bar - defaults to white
    searchIcon: {
      type: String,
      default: null
    },
    // Secure Connection text to display above search button
    secureConnectionText: {
      type: String,
      default: null
    },
    // Icon for display with the secure connection text
    secureIcon: {
      type: String,
      default: null
    },
    // Sizing for secure icon expects {height: string, width: string}
    secureIconSize: {
      type: Object,
      default() {
        return {
          height: null,
          width: null
        };
      }
    },
    // Display Start Label and state text
    startLabel: {
      type: String
    },
    // Optional icon to display with text
    textSearchIcon: {
      type: String,
      default: null
    },
    // Sizing for text search icon expects {height: string, width: string}
    textSearchIconSize: {
      type: Object,
      default() {
        return {
          height: null,
          width: null
        };
      }
    },
    // If user has permission to search
    hasPermission: {
      type: Boolean,
      default: true
    },
    // If true, emit event on submission that handles submission from parent level. ** All redirect logic will be skipped **
    noQueryString: {
      type: Boolean,
      default: false
    },
    // Optional label to use for default state if 'state' is unwanted
    defaultStateLabel: {
      type: String,
      default: 'State'
    },
    // Optional label to use for default phone if 'Phone Number' is unwanted
    defaultPhoneLabel: {
      type: String,
      default: 'Phone Number'
    },
    // Optional button icons to use for each search type
    buttonIcons: {
      type: Object
    }
  },
  data() {
    return {
      phoneRaw: '',
      error: {
        firstName: false,
        lastName: false,
        phone: false,
        street: false,
        city: false
      },
      searchType: this.initialSearchType,
      searchSubmitted: {
        people: false,
        phone: false,
        address: false
      },
      searchValidationError: {
        firstName: null,
        lastName: null,
        phone: null,
        street: null,
        city: null
      },
      streetRegex: /^[a-zA-Z0-9\s-]*$/,
      states,
      peopleIcon,
      phoneIcon,
      addressIcon
    };
  },
  watch: {
    prefillFields: {
      handler(values) {
        Object.entries(values).forEach(([key, value]) => {
          const methodName = key.charAt(0).toUpperCase() + key.slice(1);
          const validateMethod = `validate${methodName}`;
          if (validateMethod in this) {
            this[validateMethod](value);
          }
          this.prefillFields[key] = value;
        });
      },
      deep: true
    },
    initialSearchType: {
      handler(value) {
        this.searchType = value;
      }
    }
  },
  mounted() {
    // Looks a bit ugly but timeout needs to be in place for static support
    setTimeout(() => {
      // Ensure at the minimum you have firstname, lastname, city, state as empty string if it's falsy
      ['firstName', 'lastName', 'city', 'state'].forEach(field => {
        if (!this.prefillFields[field]) {
          this.prefillFields[field] = '';
        }
      });
      if (
        'phoneNumber' in this.prefillFields &&
        this.prefillFields.phoneNumber
      ) {
        const phoneValue = this.prefillFields.phoneNumber;
        this.phoneRaw = phoneValue.replace(/[^0-9]+/g, '');
        this.prefillFields.phoneNumber =
          this.phoneAreaCode + this.phonePrefix + this.phoneLine;
        if (this.peopleLink === null && this.phoneLink !== null) {
          this.searchType = searchTypes[1];
        }
      }
    }, 4);
  },
  methods: {
    isFieldInvalid: function(value) {
      //Validate Field value against the Regex if no regex passed in
      if (this.peopleInvalidRegex === null) {
        return !isValidAlphabet.test(value);
      }

      if (this.isAddressSearch()) {
        return value === '' || !this.streetRegex.test(value);
      }
      // Otherwise do not allow empty strings or anything matching invalid regex
      return value === '' || this.peopleInvalidRegex.test(value);
    },
    isPeopleSearch: function() {
      return this.hasPeopleSearch && this.searchType === searchTypes[0];
    },
    isPhoneSearch: function() {
      return this.hasOnlyPhoneSearch || this.searchType === searchTypes[1];
    },
    isAddressSearch: function() {
      return this.hasOnlyAddressSearch || this.searchType === searchTypes[2];
    },
    doNotSubmit: function() {
      // @TODO possible future optimization
      // if (Object.keys(this.error).some(k => this.error[k])) return true;

      // Fail if any errors for that search type
      if (this.isPeopleSearch()) {
        // Ensure params & copy/paste values valid on submission
        this.error.firstName = this.isFieldInvalid(
          this.prefillFields.firstName
        );
        this.error.lastName = this.isFieldInvalid(this.prefillFields.lastName);

        // Track that we have submitted a people search
        this.searchSubmitted.people = true;
        // Track the validation on submission
        this.searchValidationError.firstName = this.error.firstName;
        this.searchValidationError.lastName = this.error.lastName;

        return this.error.firstName || this.error.lastName;
      }

      if (this.isPhoneSearch()) {
        // return false is missing;
        if (
          !this.prefillFields.phoneNumber &&
          this.initialSearchType === 'phone'
        ) {
          return (this.error.phone = true);
        }

        // Ensure params & copy/paste values valid on submission
        this.error.phone = this.prefillFields.phoneNumber.length < 14;

        // Track that we have submitted a phone search
        this.searchSubmitted.phone = true;
        // Track the validation on submission
        this.searchValidationError.phone = this.error.phone;

        return this.error.phone;
      }

      if (this.isAddressSearch()) {
        // Ensure params & copy/paste values valid on submission
        this.error.street = this.isFieldInvalid(
          this.prefillFields.street || ''
        );

        if (!this.prefillFields.city) {
          this.error.city = true;
        } else {
          this.error.city = this.isFieldInvalid(this.prefillFields.city);
        }
        this.error.state = this.isFieldInvalid(this.prefillFields.state);

        // Track that we have submitted an address search
        this.searchSubmitted.address = true;
        // Track the validation on submission
        this.searchValidationError.street = this.error.street;
        this.searchValidationError.city = this.error.city;
        this.searchValidationError.state = this.error.state;

        return this.error.street || this.error.city || this.error.state;
      }

      return false;
    },
    onPeopleInput: function(event) {
      // If there is not a specific regex, skip the live input editing of invalid values
      if (this.peopleInvalidRegex === null) {
        return;
      }

      // Otherwise prevent input of invalid characters
      if (this.peopleInvalidRegex.test(event.target.value)) {
        event.preventDefault();

        this.prefillFields[event.target.name] = event.target.value.replace(
          this.peopleInvalidRegex,
          ''
        );
      }
    },
    onCityInput: function(event) {
      const nonLetterOrWhitespaceRegex = /[^a-zA-Z\s]/g;

      if (nonLetterOrWhitespaceRegex.test(event.target.value)) {
        event.preventDefault();
        this.prefillFields[event.target.name] = event.target.value.replace(
          nonLetterOrWhitespaceRegex,
          ''
        );
      }
    },
    onAddressInput: function(event) {
      const nonAlphaNumeric = /[^a-zA-Z0-9\s-]/g;

      if (!this.streetRegex.test(event.target.value)) {
        event.preventDefault();

        this.prefillFields[event.target.name] = event.target.value.replace(
          nonAlphaNumeric,
          ''
        );
      }
    },
    onPhoneInput: function(event) {
      this.phoneRaw = event.target.value.replace(/[^0-9]+/g, '');

      // If there are no digits, there is no phone
      if (this.phoneRaw === '') {
        this.prefillFields.phoneNumber = '';
      }

      // If there is still a number, display it appropriately
      if (this.phoneRaw !== '') {
        this.prefillFields.phoneNumber =
          this.phoneAreaCode + this.phonePrefix + this.phoneLine;
      }
    },
    onStateChange: function(event) {
      this.prefillFields.state = event.target.value;
      // For some reason vue doesn't seem to rerender the selection of other dropdowns when data changes for dropdowns
      [...document.querySelectorAll('select[name="state"]')].forEach(
        select => (select.value = this.prefillFields.state)
      );
    },
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return condition ? [condition] : [];
    },
    searchSubmit: function() {
      if (!this.hasPermission) {
        this.$emit('handle-no-permission');
        return;
      }

      let submittedFields = Object.assign({}, this.prefillFields);

      if (this.doNotSubmit()) return;

      if (this.noQueryString) {
        this.$emit('tz-search-override-redirect', {
          searchType: this.searchType,
          ...submittedFields
        });
        return;
      }

      // get the submission url
      const url = this.isPeopleSearch()
        ? new URL(this.peopleLink)
        : new URL(this.phoneLink);
      const searchTypeIndex = this.isPeopleSearch() ? 0 : 1;

      // modify submission fields based on type
      if (this.isPhoneSearch()) {
        submittedFields.firstName = '';
        submittedFields.lastName = '';
        submittedFields.city = '';
        submittedFields.state = '';
      } else {
        submittedFields.phoneNumber = '';
      }

      if (this.isAddressSearch()) {
        submittedFields.firstName = '';
        submittedFields.lastName = '';
      }

      // Should help with cache busting
      submittedFields.time = Date.now();

      // Merge fallback values with submission fields
      if (this.fallbackFields && this.fallbackFields[searchTypeIndex]) {
        submittedFields = Object.assign(
          this.fallbackFields[searchTypeIndex],
          submittedFields
        );
      }

      // Omit fields with an empty string
      Object.entries(submittedFields).forEach(([key, value]) => {
        if (value !== '') url.searchParams.set(key, value);
      });

      if (this.openNewWindow) {
        return window.open(url, '_blank');
      }

      window.location = url;
    },
    setSearchButtonLabel: function() {
      return this.isPhoneSearch() && this.error.phone
        ? 'Search, Disabled due to invalid phone number length'
        : 'Search';
    },
    setValidationClass: function(inputName) {
      // Null input value is due to not having yet submitted, so do not add class
      if (this.searchValidationError[inputName] === null) {
        return '';
      }

      // Otherwise, return class indicating validation result on submit
      return this.searchValidationError[inputName]
        ? 'tz-search__input-field--invalid-on-submit'
        : 'tz-search__input-field--valid-on-submit';
    },
    toggleSearchType: function(selectedType) {
      // Ignore it if they re-click same type
      if (selectedType === this.searchType) {
        return;
      }

      switch (selectedType) {
        case 'people':
          this.searchType = searchTypes[0];
          break;
        case 'phone':
          this.searchType = searchTypes[1];
          break;
        case 'address':
          this.searchType = searchTypes[2];
          break;
      }
    },
    validateCity(value) {
      if (this.isFieldInvalid(value)) {
        return (this.error.city = true);
      }
      this.error.city = false;
    }
  }
};
</script>
